import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@constants/api.routes";
import { fetchAttachmentByKey } from "@services/attachmentService";

/**
 * React Query hook to fetch attachment URL by key
 * @param key - The attachment key from the API response
 * @param enabled - Whether the query should be enabled (default: true)
 * @returns React Query result with attachment data
 */
export const useAttachment = (key: string | null | undefined, enabled: boolean = true) => {
	return useQuery({
		queryKey: [QUERY_KEYS.ATTACHMENTS.ATTACHMENT_BY_KEY, key],
		queryFn: () => fetchAttachmentByKey(key!),
		enabled: enabled && !!key,
	});
};
